import { render } from "./index.vue?vue&type=template&id=3cc0c31a"
import script from "./contact.ts?vue&type=script&lang=js"
export * from "./contact.ts?vue&type=script&lang=js"

import "./contact.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script